import { FC } from 'external/react'
import {styled} from 'external/material'

import { SkillField, SkillName } from './SkillField'

type SkillsProps = {
    skill: SkillName
}

const StyledSkills = styled('div')(skillsStyles as any)

export const Skills: FC<SkillsProps> = props => {
    
    const {skill} = props

    return (
        <StyledSkills>
            <SkillField skill={skill} field='conceptual' />
            <SkillField skill={skill} field='procedural' />
            <SkillField skill={skill} field='attitudinal' />
            <SkillField skill={skill} field='achievementIndicators' />
        </StyledSkills>
    )
}

function skillsStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(165, 211, 243, 0.1)',
        alignItems: 'center',
        padding: '16px',
        boxSizing: 'border-box',
        gap: '30px',
        marginBottom: '30px'
    }
}